import React from 'react';
import { Projects } from '../components/features/Projects/Projects';
import { AbsoluteCenter } from '../components/layout/AbsoluteCenter/AbsoluteCenter';
import { Full } from '../components/layout/Full/Full';
import { PanelLayout } from '../components/layout/Panel/Panel';

export const ProjectScreen = () => {
    return (
        <Full>
            <AbsoluteCenter top={15} size={60}>
                <PanelLayout animation={true}>
                    <Projects />
                </PanelLayout>
            </AbsoluteCenter>
        </Full>
    );
};
